var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsItem cur",on:{"click":_vm.toDetail}},[_c('span',{staticClass:"val elli"},[_vm._v(_vm._s(_vm.detail.name))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.detail.time || _vm.detail.createtime.substr(0,10)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }